import React, { useState } from "react";
import { TiTick } from "react-icons/ti";
import BannerSideImage from "../../assets/images/celebrating-growth-and-profits-with-marketeer.webp";
import SEOMastery from "../../assets/images/the-search-engine-Google-opened-on-a-laptop-screen.avif";
import SMMTechSavviness from "../../assets/images/a-person-scrolling-some-instagram-page-while-having-morning-coffee.avif";
import SwiperComponent from "../../components/SwiperComponent";
import "../../App.css";
import TechStackAnimation from "../../components/TechStackAnimation";
import CustomBanner from "../../components/CustomBanner";
import FAQSection from "../../components/FAQSection";
import {
  SearchEngineOptimization,
  SocialMediaMarketing,
} from "./AnimationTechStacks";
import { motion } from "framer-motion";
import { faqData, process } from "./DigitalMarketingData";
import { Head } from "vite-react-ssg";

const DigitalMarketing = () => {
  return (
    <>
      <Head>
        <title>Data-driven and niche-specific digital marketing solutions</title>
        <meta
          name="description"
          content="Grow your business with search engine optimization, social media management, Meta ads, Google pay-per-click, Pinterest and LLM optimization."
        />
        <link rel="canonical" href="https://apptalyst.com/digital-marketing" />
      </Head>
      <CustomBanner
        svgImg={BannerSideImage}
        svgWidth="w-[11rem] mobSmallScreen:w-[14rem]  mobMediumScreen:w-[17rem] screen-400:w-[18rem] mobileLargeScreen:w-[18rem] xs:w-[20rem] sm:w-[22rem] md:w-[23rem] lg:w-[26rem] xl:w-[28rem] "
        svgPosition="-bottom-16 md:top-[67%]  lg:top-[62%] "
        imgAlt="Marketeer celebrating growth, profits and success in business KPIs with stakeholder."
      >
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1.1] font-bold lg:w-8/12 xl:w-8/12 "
        >
          Digital Marketing Solutions
        </motion.h1>

        <ul className="space-y-2">
          <li className="flex items-start  md:items-center text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Realistic Goals from Day One
          </li>
          <li className="flex items-start  md:items-center text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Industry specific solutions
          </li>
          <li className="flex items-start  md:items-center text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Data-driven and informed decision-making
          </li>
        </ul>
      </CustomBanner>

      <section className="space-y-20 md:space-y-32 mb-20 md:mb-32">
        <section className="container space-y-14">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold capitalize text-center text-dark px-2 font-butler"
          >
            Search Engine Optimization
          </motion.h2>

          {/* Desktop Animation - show only on large screens and up */}
          <div className="hidden md:block">
            <TechStackAnimation.TechStackDesktopAnimation
              techStackAnimatedIcons={SearchEngineOptimization}
            />
          </div>

          {/* Mobile Animation - show only on small and medium screens */}
          <div className="block md:hidden">
            <TechStackAnimation.TechStackMobileAnimation
              techStackAnimatedIcons={SearchEngineOptimization}
            />
          </div>
        </section>

        <section className=" bg-gray-50  py-20 px-3 sm:px-10 md:px-8">
          <div className="container ">
            <div className="flex flex-col md:flex-row rounded-xl overflow-hidden text-dark shadow-md  bg-[#f3ebfa] h[30rem] ">
              <div className="w-full md:w-6/12">
                <img
                  src={SEOMastery}
                  alt="The search engine Google, opened on a laptop screen by some potential customer looking for a service or product."
                  className="h-full w-full"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-6 xl:px-7 space-y-4 ">
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                  className="textgray-700 text-2xl md:text-3xl font-bold"
                >
                  Our SEO Mastery
                </motion.h2>
                <ul className="space-y-2 text-base md:text-lg">
                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg ">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        Competitor & Market Gap Analysis:{" "}
                      </span>
                      We identify opportunities in your specific industry and
                      the benchmarks set by your competitors to plan your SEO
                      strategy accordingly.
                    </p>
                  </li>

                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        Crystal-Clear Performance Reporting:
                      </span>{" "}
                      Our monthly performance reports track rankings, traffic
                      quality and provide with actionable insights to improvise
                      the action plan.
                    </p>
                  </li>

                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg"> White-Hat Excellence:</span>{" "}
                      We strictly adhere to Google’s and other search engine's
                      guidelines and best-practices through semantic SEO,
                      E-E-A-T alignment, and sustainable link-building.
                    </p>
                  </li>
                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        {" "}
                        Full-Spectrum Expertise:{" "}
                      </span>{" "}
                      From technical audits to content optimization, we sweat
                      every detail to ensure your visibility.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="container space-y-14">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold capitalize text-center text-dark px-10 md:px-0 font-butler"
          >
            Social Media Marketing
          </motion.h2>
          {/* Desktop Animation - show only on large screens and up */}
          <div className="hidden md:block">
            <TechStackAnimation.TechStackDesktopAnimation
              techStackAnimatedIcons={SocialMediaMarketing}
            />
          </div>

          {/* Mobile Animation - show only on small and medium screens */}
          <div className="block md:hidden">
            <TechStackAnimation.TechStackMobileAnimation
              techStackAnimatedIcons={SocialMediaMarketing}
            />
          </div>
        </section>

        <section className=" bg-gray-50  py-20 px-3 sm:px-10 md:px-8 ">
          <div className=" container ">
            <div className="flex flex-col md:flex-row rounded-xl overflow-hidden text-dark shadow-md  bg-[#f3ebfa] ">
              <div className="w-full md:w-6/12">
                <img
                  src={SMMTechSavviness}
                  alt="A person scrolling some Instagram page related to food while having morning coffee."
                  className="h-full w-full"
                  loading="lazy"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-6 xl:px-7 space-y-4 ">
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                  className="textgray-700 text-2xl md:text-3xl font-bold"
                >
                  Our SMM Tech Savviness
                </motion.h2>
                <ul className="space-y-2 text-base md:text-lg">
                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        Consumer Psychology and Relevance Analysis:{" "}
                      </span>{" "}
                      We begin with researching the behavior of your target
                      audience and the relevance of your product or service
                      specific content on all platforms.
                    </p>
                  </li>

                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        {" "}
                        Transparent Performance Metrics:{" "}
                      </span>{" "}
                      Our evaluation of the marketing campaigns are based on
                      pertinent qualitative and quantitative indicators.
                    </p>
                  </li>

                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        {" "}
                        Platform-specific content:{" "}
                      </span>
                      Our content strategy is tailored to each social media
                      platform’s audience and algorithms.
                    </p>
                  </li>
                  <li className="flex items-start  space-x-2">
                    <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 text-base md:text-lg">
                      <TiTick />
                    </span>
                    <p className="text-base leading-[1.625rem]">
                      <span className="font-bold text-base md:text-lg">
                        {" "}
                        Organic Engagement and Networking:{" "}
                      </span>{" "}
                      We cultivate authentic brand communities through loveable
                      content and meaningful interactions.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="container">
          <FAQSection faqData={faqData} />
        </section>
      </section>
    </>
  );
};

export default DigitalMarketing;
